import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile } from "../service/profileService";
import userProfileImage from "../../../assets/images/user.svg";

const DropDownProfile = ({
  dropdownRef,
  handleMouseEnter,
  handleMouseLeave,
  handleClick,
  showDropdown,
  Link,
  userData,
}) => {
  const navigate = useNavigate();

  const [profile, setProfile] = useState(null);

  // Get profile data
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();

        if (data?.success) {
          setProfile(data.data);
        }
      } catch (error) {
        console.error("Profile API Error:", error);
      }
    };

    fetchProfile();
  }, []);

  // API response:
  // data.user_role_id = 5 / 12
  const roleId = Number(profile?.user_role_id);

  // Service-wise permission
  const showQrCodeScan = roleId === 5;
  const accessUser = profile?.username;


  // User name
  const storedUserName = localStorage.getItem("user") || "";

  const rawUserName =
    profile?.name ||
    userData ||
    storedUserName ||
    "User";

  const firstName = rawUserName.trim().split(" ")[0];

  const userName =
    firstName.charAt(0).toUpperCase() +
    firstName.slice(1).toLowerCase();

  // Logout
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.removeItem("otpLogin");
    localStorage.removeItem("request_id");
    localStorage.removeItem("user");
    localStorage.removeItem("userData");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("customer_id");
    localStorage.removeItem("customerId");

    navigate("/", { replace: true });
  };

  return (
    <div className="box-wishlist box-dropdowns">
      <div
        className="dropdown"
        ref={dropdownRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          className="btn btn-secondary dropdown-toggle bg-remove"
          type="button"
          onClick={handleClick}
          aria-expanded={showDropdown}
          style={{
            padding: 0,
            display: "inline-flex",
            background: "transparent",
            border: "none",
            alignItems: "center",
          }}
        >
          <span style={{ marginRight: "5px" }}>
            <img
              src={userProfileImage}
              height={20}
              className="img-responsive"
              alt="user"
            />
          </span>

          {userName}
        </button>

        <ul
          className={`dropdown-menu${showDropdown ? " show" : ""} m001`}
          style={{
            position: "absolute",
            backgroundColor: "#0000007a",
          }}
        >
          {/* My Account */}

      

          <li>
            <Link
              className="dropdown-item borderbottom"
              to="/account/orders"
            >
              <i className="bi bi-people"></i> My Account
            </Link>
          </li>

          {/* QR Code Scan
              Role ID 5  => SHOW
              Role ID 12 => HIDE
          */}
          {showQrCodeScan && (
            <li>
              <Link
                className="dropdown-item borderbottom"
                to="/scanner"
              >
                <i className="bi bi-qr-code-scan"></i>{" "}
                QR Order
              </Link>
            </li>
          )}

          <li>
            <Link
              className="dropdown-item borderbottom"
              to="/cart?comingsoon=1"
            >
              <i className="bi bi-bag-check"></i> Pre Order
            </Link>
          </li>

          {/* QR Code Scan
              Role ID 5  => SHOW
              Role ID 12 => HIDE
          */}
          {(accessUser === "ParulVerma" || accessUser === "mantu" || accessUser === "omprakash" || accessUser === "tapan"  || accessUser === "dileep") && (
              <li>
                <a
                  className="dropdown-item borderbottom"
                  href="https://manage.obsessionsindia.in/master/media"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-image"></i>{" "}
                  Upload Media
                </a>
              </li>
            )}

          {/* Logout */}
          <li>
            <button
              type="button"
              className="dropdown-item"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right"></i>{" "}
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DropDownProfile;
